const cdn = 'https://cdn.himam.com';
const publicCdn = `${cdn}/public`;
const landing = `${publicCdn}/landing`;
const attachment = `${publicCdn}/attachment`;
const instructorPublic = `${cdn}/instructor/public`;
// No trailing slash — every usage interpolates `${oracle}/…`, and the
// resulting `…spaces.com//staging/…` double-slash URLs return 403 from the
// bucket (KP-53).
const oracle = 'https://io1.sgp1.cdn.digitaloceanspaces.com';
export const ExternalUrlsEnum = {
  jsons: {
    countries: `${publicCdn}/jsons/countries.json`,
  },
  images: {
    himam: {
      logo: `${landing}/schfs-logo.webp`,
    },
    auth: {
      loginBackground: `${publicCdn}/landing/auth/login-background.webp`,
    },
    notifications: {
      announcment: `${oracle}/staging/media/image/png/_12cd07banotificationAnnouncments.png`,
      certificate: `${oracle}/staging/media/image/png/_4a46ac9cnotificationcertificate.png`,
      checklist: `${oracle}/staging/media/image/png/_4178d819notificationLearningPath.png`,
      discussionBoard: `${oracle}/staging/media/image/png/_5d0d96e8notificationDiscussionBorads.png`,
      grading: `${oracle}/staging/media/image/png/_f212267bnotificationGrading.png`,
      event: `${publicCdn}/defaultImages/event.webp`,
      course: `${publicCdn}/defaultImages/course.webp`,
      group: `${publicCdn}/defaultImages/group.webp`,
    },
    default: {
      course: `${instructorPublic}/images/course.webp`,
      courseIcon: `${instructorPublic}/images/online-learning.png`,
      coverImage: `${publicCdn}/defaultImages/social-default-cover.png`,
    },
    events: {
      QrCode: `${publicCdn}/defaultImages/Qr.jpeg`,
    },
  },
  SVGs: {
    himamLogo: `${publicCdn}/svgs/himam-logo.svg`,
    smallLogo: `${publicCdn}/defaultImages/svg/smallLogo.svg`,
    fileIcon: `${instructorPublic}/svgs/file.svg`,
    imgIcon: `${publicCdn}/svgs/Frame.svg`,
    videoIcon: `${instructorPublic}/svgs/video.svg`,
    emptyIcon: `${instructorPublic}/svgs/empty.svg`,
    lines: `${instructorPublic}/svgs/lines.svg`,
    zoomIcon: `${instructorPublic}/svgs/zoom.svg`,
    rubricHintIcon: `${instructorPublic}/svgs/checklist.svg`,
    laptopIcon: `${instructorPublic}/svgs/laptop.svg`,
    zoom: `${publicCdn}/svgs/zoom.svg`,
    publicCourse: `${publicCdn}/svgs/publicCourse.svg`,
    noTranslation: `${publicCdn}/svgs/no-translation-icon.svg`,

    quiz: {
      fileIcon: `${instructorPublic}/svgs/quiz/file.svg`,
      imageIcon: `${instructorPublic}/svgs/quiz/image.svg`,
      pdfIcon: `${instructorPublic}/svgs/quiz/quiz-pdf.svg`,
      videoIcon: `${instructorPublic}/svgs/quiz/video.svg`,
    },
    default: {
      user: `${instructorPublic}/svgs/user.svg`,
      notFound: `${publicCdn}/defaultImages/notFound404.webp`,
      unauthorized: `${publicCdn}/defaultImages/unauthorized.webp`,
    },
    attachment: {
      mp3: `${attachment}/mp3.svg`,
      video: `${attachment}/video.svg`,
      image: `${attachment}/image.svg`,
      pdf: `${attachment}/pdf.svg`,
      doc: `${attachment}/doc.svg`,
      ppt: `${attachment}/ppt.svg`,
      xls: `${attachment}/xls.svg`,
      word: `${attachment}/word.svg`,
      link: `${attachment}/link.svg`,
    },
    guideLine: {
      content: `${publicCdn}/svgs/content.svg`,
    },
  },
};
